import { Button, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@truvhq/ui';

import fannieProvider from 'assets/images/promo/fannie_provider_logo.png';
import iPhone from 'assets/images/promo/iPhone.png';
import voa from 'assets/images/promo/voa.svg';

type Props = {
  href: string;
  onClick: () => void;
  onClose: () => void;
  open: boolean;
};

export const VOAModal = ({ href, onClick, onClose, open }: Props) => {
  return (
    <Dialog
      PaperProps={{
        className: 'w-[560px] overflow-hidden z-0 rounded-3xl h-[698px] rounded-[34px]',
        sx: {
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            background: 'linear-gradient(225deg, #82a3ef 0%, #3c75d3 35%, #1e3a8a 70%, #060f1e 100%)',
            backgroundPosition: '0 0',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
          '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            backgroundImage: `url("${iPhone}")`,
            backgroundColor: 'transparent',
            backgroundPosition: '50% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '47%',
          },
        },
      }}
      open={open}
    >
      <DialogContent className="relative flex flex-col items-center text-center">
        <IconButton aria-label="close" className="absolute right-4 top-4 text-white/70" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography className="mt-10 max-w-[440px] text-[32px] leading-[115%] text-white/70">
          <span className="text-white">Truv</span> is now an authorized <span className="text-white">asset</span> report
          supplier for <span className="text-white">Fannie&nbsp;Mae&#39;s Desktop Underwriter® (DU®)</span> validation
          service!
        </Typography>

        <Button
          className="mt-7 bg-white text-grey100 hover:bg-white/70 active:bg-white/70"
          href={href}
          target="_blank"
          variant="contained"
          onClick={onClick}
        >
          Learn more
        </Button>
        <div className="absolute bottom-[250px] right-[83px] flex h-[120px] w-[120px] items-center justify-center rounded-[20px] bg-white shadow-[-8px_8px_20px_0px_rgba(0,0,0,0.10)]">
          <img alt="Fannie Mae certification" height={120} src={fannieProvider} width={120} />
        </div>
        <div className="absolute bottom-[60px] left-[66px] flex h-[120px] w-[120px] items-center justify-center rounded-[20px] border border-[1px] border-[#cecece36] bg-white/10 backdrop-blur-xl">
          <img alt="Verification of Assets" src={voa} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
